import type { InputHTMLAttributes } from 'react';

import { CheckIcon } from 'lucide-react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  id: string;
};

const Checkbox = ({ id, className, ...props }: Props) => (
  <label
    htmlFor={id}
    className={`relative flex shrink-0 w-8 sm:w-6 aspect-square cursor-pointer items-center justify-center ${className}`}
  >
    <input
      type="checkbox"
      id={id}
      {...props}
      className="peer appearance-none w-5 h-5 rounded-full border border-black transition-colors checked:border-samsungBlue"
    />
    <div className="absolute border-primary text-primary aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-5 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] disabled:cursor-not-allowed disabled:opacity-50" />
    <CheckIcon
      color="white"
      className="bg-samsungBlue absolute p-0.5 size-5 rounded-full hidden peer-checked:block"
    />
  </label>
);

export default Checkbox;
